import script from "./PlayerCategoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerCategoryCard.vue?vue&type=script&setup=true&lang=js"

import "./PlayerCategoryCard.vue?vue&type=style&index=0&id=06b35fb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b35fb2"]])

export default __exports__